import styled from "styled-components";

export const EmployeeDataWrapper = styled.section`
  max-width: 800px;
  display: flex;
  flex-direction: row;
  /* justify-content: space-between; */
  align-items: center;
  & > div {
    width: 40%;
  }
`;

export const VerticalDivider = styled.div`
  width: 1px;
  height: 80px;
  margin: 4rem 8rem 0 8rem;
  background-color: #c6c2c2;
`;

export const CutoffDate = styled.input`
  font-size: 14px;
  width: 100%;
  padding: 10px;
  border: ${props => `1px solid ${props.theme.primaryColor}`};
  border-radius: 10px;
`